export const DEFAULT_TITLE = 'default_file_title'